<div class="p-2">
  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">
      <span *ngIf="pageMode == 'add'">Create Circular</span>
      <span *ngIf="pageMode == 'edit'">Edit Circular</span>
    </div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <div class="row pt-2 pb-2 bg-white">
        <div class="col-12">

          <button type="button" class="btn btn-outline-danger btn-sm float-end" *ngIf="pageMode == 'edit'" (click)="onDeleteCircularClick(circular_save_confirm_modal)">Delete Circular</button>

          <!-- Stores ====================================== -->
          <div class="row mt-2">
            <div class="col-12">
              <span class="text-muted fw-bold">
                Stores
                <i-bs
                  name="infoCircle"
                  class="text-primary"
                  tooltip="Select or more stores for the circular."
                  placement="top">
                </i-bs>
              </span>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <ng-multiselect-dropdown
                [disabled]="storeSelectionDisabled"
                [placeholder]="'Select'"
                [settings]="storeSelectionSettings"
                [data]="stores"
                [(ngModel)]="selectedStores"
                (onSelect)="onStoreSelect($event)"
                (onDeSelect)="onStoreDeSelect($event)">
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <!-- Circular Name ====================================== -->
              <div class="row mt-4">
                <div class="col-12">
                  <span class="text-muted fw-bold">
                    Circular Name
                    <i-bs
                      name="infoCircle"
                      class="text-primary"
                      tooltip="Add name of the circular. Max no of characters are 100."
                      placement="top">
                    </i-bs>
                  </span>

                  <input type="text" class="form-control mt-2" id="circular_name" maxlength="100" placeholder="E.g. Black Friday Sale" [(ngModel)]="circularName">
                </div>
              </div>

              <!-- Circular Dates ====================================== -->
              <div class="row mt-4">
                <div class="col-12">
                  <span class="text-muted fw-bold">
                    Start & End Date
                    <i-bs
                      name="infoCircle"
                      class="text-primary"
                      tooltip="Select start and end date of the circular."
                      placement="top">
                    </i-bs>
                  </span>

                  <input type="text" class="form-control text-muted mt-2" id="date_range" placeholder="Select circular date range" bsDaterangepicker [bsConfig]="calendarConfig" [minDate]="calendarMinDate" [bsValue]="circularDateRange" (bsValueChange)="onCalendarValueChange($event)">
                </div>
              </div>
            </div>
            <div class="col-6">
              <!-- Circular Images ====================================== -->
              <div class="row mt-4">
                <div class="col-12">
                  <span class="text-muted fw-bold">
                    Select Image
                    <i-bs
                      name="infoCircle"
                      class="text-primary"
                      tooltip="Add one or more images for circular. Max file size is 1 Mb. File types supported are png & jpg."
                      placement="top">
                    </i-bs>
                  </span>

                  &nbsp;<div class="spinner-grow spinner-grow-sm text-secondary" role="status" *ngIf="circularImageSelecting"></div>

                  <div class="row mt-2">
                    <div class="col-12">
                      <ngx-dropzone style="height: 125px;" [multiple]="true" (change)="circularImageSelect($event)">
                        <ngx-dropzone-label>Click or Drag & Drop your circular image here <br> Files supported - png & jpeg <br> Max file size 1 Mb</ngx-dropzone-label>
                        <ngx-dropzone-preview *ngFor="let imageFile of circularImageFilesDropzone" [removable]="true" (removed)="circularImageRemove(imageFile)">
                          <ngx-dropzone-label>{{ imageFile.name }} ({{ imageFile.type }})</ngx-dropzone-label>
                        </ngx-dropzone-preview>
                      </ngx-dropzone>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Preview ====================================== -->
          <span *ngIf="circularImageFilesSelected.length > 0">
            <div class="row mt-4">
              <div class="col-12">
                <span class="text-muted fw-bold">Circular Images</span>
              </div>
            </div>
            <div class="row mt-4 text-center">
              <div class="col-3 mb-4 preview-outer border-end" *ngFor="let image of circularImageFilesSelected; let i = index">
                <span class="text-muted preview-label">Page {{ i+1 }}</span>

                <img class="preview-img img-fluid mt-2 mb-2" [src]="image.file_base64" *ngIf="image.file_base64">
                <img class="preview-img img-fluid mt-2 mb-2" [src]="image.file_s3" *ngIf="image.file_s3 && !image.file_base64">

                <i-bs class="text-danger cursor-pointer" name="trash3" [ngbPopover]="imgDeletePopoverContent" [popoverTitle]="imgDeletePopoverTitle" placement="top" (click)="circularPageRemoveConfirm(image)"></i-bs>
              </div>
            </div>
          </span>

          <!-- Save Button -->
          <div class="row mt-3 pt-3 mb-0 border-top">
            <div class="col-6">
            </div>
            <div class="col-6 text-end">
              <button type="button" class="btn btn-secondary text-white fw-bold" title="Save Circular" (click)="onSaveCircularClick(circular_save_confirm_modal)">
                <i-bs class="text-light" name="cloudArrowUp" width="22" height="22"></i-bs>
              </button>
            </div>
          </div>

        </div>
      </div>
      
    </div>
  </div>
</div>

<!-- Circular image delete popover -->
<ng-template #imgDeletePopoverTitle>Remove Image</ng-template>
<ng-template #imgDeletePopoverContent>
  <div>Are you sure you want to remove this image?</div>
  <div class="float-end mb-2">
    <button type="button" class="btn btn-outline-dark btn-sm" title="Cancel">No</button>
    &nbsp;<button type="button" class="btn btn-outline-danger btn-sm" title="Remove image" (click)="circularPageRemove()">Yes</button>
  </div>
</ng-template>

<!-- Circular Save Confirm Modal -->
<ng-template #circular_save_confirm_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start" *ngIf="pageMode == 'add'">Create Circular</h6>
    <h6 class="modal-title text-muted float-start" *ngIf="pageMode == 'edit' &&  isDeleteCircular == false">Edit Circular</h6>
    <h6 class="modal-title text-danger float-start" *ngIf="pageMode == 'edit' &&  isDeleteCircular == true">Delete Circular</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideCircularSaveConfirmModal()"></i-bs>
  </div>

  <div class="modal-body">
    <p class="text-muted" *ngIf="pageMode == 'add'">Are you sure you want to create this circular?</p>
    <p class="text-muted" *ngIf="pageMode == 'edit'  &&  isDeleteCircular == false">Are you sure you want to edit this circular?</p>
    <p class="text-muted" *ngIf="pageMode == 'edit'  &&  isDeleteCircular == true">Are you sure you want to delete this circular?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-dark fw-bold" title="Cancel" [disabled]="savingCircular" (click)="hideCircularSaveConfirmModal()">
      No
    </button>

    <button type="button" class="btn btn-secondary text-white fw-bold" title="Create Circular" [disabled]="savingCircular" (click)="createCircular()" *ngIf="pageMode == 'add' ||  (pageMode == 'edit' &&  isDeleteCircular == false)">
      Yes
      <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingCircular"></div>
    </button>

    <button type="button" class="btn btn-danger text-white fw-bold" title="Create Circular" [disabled]="savingCircular" (click)="deleteCircular()" *ngIf="pageMode == 'edit' &&  isDeleteCircular == true">
      Yes
      <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingCircular"></div>
    </button>
  </div>
</ng-template>


